import { Form, Image, Input, Row } from 'antd';
import { ColProps } from 'antd/lib/col';
import { Rule } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import { InputProps } from 'antd/lib/input';
import { LiteralUnion } from 'antd/lib/_util/type';
import Paragraph from 'components/atoms/Paragraph';
import { Context } from 'components/hoc/Store';
import InfoTooltip from 'components/molecules/InfoTooltip';
import React, { useContext } from 'react';
import getLanguageObject from 'utils/getLanguageObject';
import nepovoleneZnakyValidation from 'utils/validations/nepovoleneZnakyValidation';

const { Item } = Form;

interface IInput extends InputProps {
    label?: string;
    labelAlign?: 'left' | 'right';
    name: string;
    className?: string;
    type?: LiteralUnion<'text' | 'password' | 'email' | 'tel', string>; // Dle potreby lze pridat dalsi typy
    initialValue?: string | number;
    rules?: Rule[]; // Pro ted disabled nevime co vse budeme potrebovat a jak to budeme zapisovat
    idCaptcha?: number;
    dependencies?: NamePath[]; // pouzit napr pri validacii 2 poli ktore suvisia = heslo / heslo overeni
    imageCaptcha?: string;
    extramessage?: string;
    /** Urcuje sirku labelu */
    labelCol?: ColProps;
    labelTextMaxWidth?: number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    infoTooltipText?: string;
    notRequired?: boolean;
    validateTrigger?: string | string[];
    hide?: boolean; // ak nechceme zobrazit komponentu ale ponechat jej value
    validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating' | undefined;
    usePscFormater?: boolean;
    // message?: string;
    // maxLength?: number;
    // validation: ((form: FormInstance) => RuleObject); // Potrba vyresit validator, bud najit zpusob jak to rozdelit (TypeScript) nebo posilat v rules
}
// Zakladni Input componenta, TODO mozne pripojeni na context pro nacitani a zapisovani dat
const InputComponent: React.FC<IInput> = props => {
    const { language } = useContext(Context);
    const {
        label,
        labelAlign,
        name,
        className = '',
        type = 'text',
        initialValue,
        idCaptcha = 0,
        imageCaptcha,
        dependencies = [],
        rules = nepovoleneZnakyValidation('NEVALIDNI_POVINNA_POLOZKA'),
        notRequired,
        extramessage = '',
        labelCol,
        labelTextMaxWidth,
        validateTrigger,
        validateStatus,
        onChange,
        onBlur,
        hide,
        usePscFormater,
        infoTooltipText = '',
        ...rest
    } = props;
    return (
        <>
            {!!idCaptcha && (
                <Row justify="start">
                    <Image
                        id={idCaptcha.toString()}
                        alt="captcha"
                        src={imageCaptcha}
                        style={{
                            marginBottom: '10px'
                        }}
                        preview={false}
                    />
                </Row>
            )}
            <Item
                style={
                    hide
                        ? {
                              display: 'none'
                          }
                        : {}
                }
                label={
                    label ? (
                        <>
                            <Paragraph
                                text={label}
                                strong={true}
                                style={{
                                    maxWidth: labelTextMaxWidth ?? 186
                                }}
                            />{' '}
                            {infoTooltipText && <InfoTooltip title={infoTooltipText} />}{' '}
                        </>
                    ) : null
                }
                labelAlign={labelAlign}
                className={className}
                name={name}
                initialValue={initialValue}
                dependencies={dependencies}
                rules={notRequired ? undefined : rules}
                extra={extramessage && <Paragraph text={extramessage} className="extramessage-text" />}
                labelCol={labelCol}
                validateTrigger={validateTrigger}
                validateStatus={validateStatus}
                normalize={
                    usePscFormater
                        ? (value: string) => {
                              const splitVal = value.replace(/\s/g, '').split('');
                              splitVal.length > 3 && splitVal[3] !== ' ' && splitVal.splice(3, 0, ' ');
                              return splitVal.length > 3 ? splitVal.join('') : value;
                          }
                        : undefined
                }
            >
                <Input
                    type={type}
                    placeholder={props.disabled ? '' : getLanguageObject(language).VYPLNTE_PLACEHOLDER || 'Vyplňte...'}
                    className="input-component"
                    onChange={onChange}
                    onBlur={onBlur}
                    {...rest}
                />
            </Item>
            {extramessage && <Paragraph text={extramessage} className="extramessage-text" />}
        </>
    );
};

export default InputComponent;
